import PolicyIcon from '@material-ui/icons/Policy';
import React, { useEffect } from 'react';

import Card from '../../../common/card/Card';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import InlineForm from '../../../common/inline/InlineForm';
import InlineSelect from '../../../common/inline/InlineSelect';
import InlineTextField from '../../../common/inline/InlineTextField';
import { User } from '../../../user/User.interface';
import { CapaRootCause, BaseCapaCardProps } from '../Capa.interface';
import { useUpdateCapa } from '../Capa.hook';
import InlineFormik from '../../../common/inline/InlineFormik';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { InlineFormControl } from '../../../common/inline/InlineFormControl';
import SingleUserSelector from '../../users/components/SingleUserSelector';

export const CapaInvestigationCard: React.FC<BaseCapaCardProps> = props => {
  const { capa, setErrorMessage, setSuccessMessage } = props;
  const { isFieldDisabled } = useTaskEntityFields(capa.task);
  const [{ data: updatedCapa, isLoading, error }, update] = useUpdateCapa(
    capa.id
  );
  useEffect(() => {
    if (updatedCapa?.id) setSuccessMessage('CAPA successfully updated');
  }, [setSuccessMessage, updatedCapa]);

  useEffect(() => {
    if (Boolean(error)) setErrorMessage('There was an error saving');
  }, [setErrorMessage, error]);
  if (!capa.id) return null;
  return (
    <InlineFormik
      initialValues={
        {
          ...capa,
          investigator: capa.investigator?.id || ''
        } as any
      }
      isSubmitting={isLoading}
      error={error}
      onSubmit={updatedValue => {
        update({
          ...updatedValue
        });
      }}
    >
      {({ values, setFieldValue, submitForm }) => (
        <Card>
          <CardTitle>
            <PolicyIcon />
            Investigation
          </CardTitle>
          <CardContent padding='large'>
            <InlineForm>
              <InlineFormControl label='Investigator'>
                <SingleUserSelector
                  value={values.investigator}
                  textFieldProps={{
                    label: undefined,
                    placeholder: 'Select a user to assign as the Investigator'
                  }}
                  disabled={isFieldDisabled('investigator')}
                  onChange={(user: User | null) => {
                    setFieldValue('investigator', user?.id, true);
                    submitForm();
                  }}
                />
              </InlineFormControl>
              <InlineSelect
                name='rootCause'
                label='Root Cause'
                disabled={isFieldDisabled('rootCause')}
                grid={{ xs: 6 }}
                options={Object.values(CapaRootCause)}
              />
              <InlineTextField
                name='rootCauseRationale'
                label='Root Cause Rationale'
                disabled={isFieldDisabled('rootCauseRationale')}
                multiline
              />
            </InlineForm>
          </CardContent>
        </Card>
      )}
    </InlineFormik>
  );
};

export default CapaInvestigationCard;
